import React from "react"
import { AppFunctionComponent } from "../../../types"
import styled from "styled-components"
import { ArrowContainer } from "../slider.component"
import useTranslationHook from "../../../hooks/use-translation.hook"

export interface Navigation {
  count: number
  index: number
  onIndexChange: (index: number) => void
}

export const ControlsPrevIcon: AppFunctionComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13.2929 6.05078L7.58594 11.7578L13.2929 17.4648L14.7069 16.0508L10.4139 11.7578L14.7069 7.46478L13.2929 6.05078Z"
      fill="black"
    />
  </svg>
)

export const ControlsNextIcon: AppFunctionComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.70697 17.707L15.414 12L9.70697 6.29297L8.29297 7.70697L12.586 12L8.29297 16.293L9.70697 17.707Z"
      fill="black"
    />
  </svg>
)

const ArrowPrev = styled(ArrowContainer)`
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  border: 2px solid ${({ color }) => color ?? "#000"};
  font-family: Facto;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  text-transform: uppercase;
  background: transparent;
  color: ${({ color }) => color ?? "#000"};
  transition: opacity 0.3s ease-in-out;
  height: unset;
  position: absolute;
  width: unset;
`

const ArrowNext = styled(ArrowContainer)`
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  border: 2px solid ${({ color }) => color ?? "#000"};
  font-family: Facto;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  text-transform: uppercase;
  background: transparent;
  color: ${({ color }) => color ?? "#000"};
  transition: opacity 0.3s ease-in-out;
  height: unset;
  position: absolute;
  right: 0;
  width: unset;
`

export interface Navigation {
  count: number
  index: number
  onIndexChange: (index: number) => void
}

const SliderArrows: AppFunctionComponent<Navigation> = ({
  count,
  index,
  onIndexChange,
}) => {
  const { dynamicTranslate } = useTranslationHook()
  const indexHigherThanZero = index > 0
  const indexLowerThanLastItem = index < count - 1

  const prev = () => indexHigherThanZero && onIndexChange(index - 1)

  const next = () => indexLowerThanLastItem && onIndexChange(index + 1)

  return (
    <>
      <ArrowPrev
        onClick={prev}
        active={indexHigherThanZero}
        data-testid="prev-arrow"
      >
        <ControlsPrevIcon />
        {dynamicTranslate("PREV")}
      </ArrowPrev>
      <ArrowNext
        onClick={next}
        active={indexLowerThanLastItem}
        data-testid="next-arrow"
      >
        {dynamicTranslate("NEXT")}
        <ControlsNextIcon />
      </ArrowNext>
    </>
  )
}

export default SliderArrows
